import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-wrapper" }
const _hoisted_2 = { class: "app-main" }

import { useAuthStore } from "@/stores/auth";
import TopBar from "@/components/layout/TopBar.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppContainer',
  setup(__props) {

const authStore = useAuthStore();

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(authStore).isLoggedIn)
      ? (_openBlock(), _createBlock(TopBar, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_RouterView)
    ])
  ]))
}
}

})